/* eslint-disable no-unused-vars */
import { useEffect, useState, useRef } from 'react'
import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import {
  AutoCompleteInput,
  InputTypes,
  NumberInput,
  TextInput,
  formatQuestionName,
  RadioButtonInput,
  SelectInput,
  PorcentInput,
} from './FormUtils'
import PropTypes from 'prop-types'
import { insertMonitoringAndEvaluationQuestionnaireAnswers } from '../../../services/MonitoreoYEvaluacion/create'
import swal from 'sweetalert'

const ROOT_ID = 0
const ROOT_FIELD_TYPE = InputTypes.SUBCATEGORY

export default function FormQuestions({
  questionStructure,
  QuestionnaireAnnexAnswer,
  setQuestionnaireAnnexAnswer,
  formikData,
  validate,
  setValidForm,
  handleSubmit,
  setValidate,
  validateFormStatus,
  ref,
}) {
  const [availableAnswers, setAvailableAnswers] = useState(null)
  const [questionsStructure, setQuestionStructure] = useState(null)
  useEffect(() => {
    setAvailableAnswers(QuestionnaireAnnexAnswer)
    setQuestionStructure(questionStructure)
  }, [])

  useEffect(() => {
    // Simular Fetch, si no hay data guardada asignar arreglo vacio
    if (availableAnswers !== null) setQuestionnaireAnnexAnswer(availableAnswers)
  }, [availableAnswers])

  // TODO: Opcional para mayor control o para revertir
  // const mergeWithLocalValues = (incomingQuestionStructure) => {
  //   let mergedQuestionStructure = [];
  //   //availableAnswers => null o puede tener valores
  //   setQuestionStructure(mergedQuestionStructure);
  // };

  const handleChange = (id, value, level, type) => {
    // console.log("handleChange",{id, value, level, type})
    if (level !== null) {
      setAvailableAnswers((prev) => {
        let obj = [...prev]
        const newObj = {
          IdAdaptabilityQuestion: id,
          Answer: value,
          IdAnswerType: type,
        }
        obj[level] = newObj
        // Limpia el resto (a la derecha) del arreglo.
        obj = obj.slice(0, level + 1)
        return obj
      })
    }
  }

  const handleBlur = (e, level, type) => {
    const name = e.target.name
    const value = e.target.value

    if (level && name) {
      setAvailableAnswers((prev) => {
        const obj = prev
        const newObj = {
          IdAdaptabilityQuestion: name,
          Answer: value,
          AnswerType: type,
        }
        obj[level] = newObj
        return obj
      })
    }
  }

  const setFieldValue = (id, value, level, type) => {
    if (id) {
      setAvailableAnswers((prev) => {
        const obj = [...prev]
        const newObj = {
          IdAdaptabilityQuestion: id,
          Answer: value,
          AnswerType: type,
        }
        obj[level] = newObj
        return obj
      })
    }
  }

  const validateFields = () => {
    let valid = true
    const incorrectFields = []

    if (availableAnswers === null) {
      return false
    }

    const validatedAnswers = availableAnswers?.map((answer, index) => {
      const unmodifiedAnswer = { ...answer }

      const isSubCategory = answer.IdAnswerType === InputTypes.SUBCATEGORY

      let validValue
      let currentValue
      if (isSubCategory) {
        validValue = answer.IdAdaptabilityQuestion !== null
        currentValue = answer.IdAdaptabilityQuestion
      } else {
        validValue = answer.Answer !== null && answer.Answer !== ''
        currentValue = answer.Answer
      }

      if (!validValue) {
        // TODO: Llamar funcion que valide y asigne el error segun el tipo de control
        // validarNumero(currentValue)
        // answer["error"] = validar(currentValue, tipo );
        const varAnswer = 'error'
        answer[varAnswer] = 'Campo Requerido'
        incorrectFields.push({ index, answer })
        valid = false
      } else {
        const varAnswer = 'error'
        answer[varAnswer] = ''
      }

      return answer
    })

    if (valid) {
      // TODO: Submit Form
      // console.log('valido formulario')
      // console.log('valido!', validatedAnswers)
      // console.log('Campos invalidos', incorrectFields)
      setValidate(false)
      // handleSubmit()
      validateFormStatus()
      setValidForm(true)
    } else {
      // handleSubmit()
      setValidate(false)

      alertValidationFields()
      console.log('Invalido!', validatedAnswers)
      console.log('Campos invalidos', incorrectFields)
      setValidForm(false)
      setAvailableAnswers((prev) => {
        return validatedAnswers
      })
    }
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
    })
  }

  useEffect(() => {
    validateFields()
  }, [validate])

  return (
    <>
      <div>
        <Typography>Pregunta Clave</Typography>
      </div>

      {/* Llamando el componente */}
      {/* TODO: validar que ya esta disponible questionsStructure */}

      <Grid item xs={12} sm={12} md={12}>
        {availableAnswers && questionsStructure && (
          <CustomForm
            questionsStructure={questionsStructure}
            availableAnswers={availableAnswers}
            level={0}
            setAvailableAnswers={setAvailableAnswers}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            handleBlur={handleBlur}
            parentValue={null}
            formikData={formikData}
          />
        )}
      </Grid>

      {/* <button onClick={validateFields}>Validar</button> */}
    </>
  )
}

function CustomForm({
  questionsStructure,
  availableAnswers,
  setAvailableAnswers,
  parentValue,
  parentValueType,
  handleChange,
  handleBlur,
  setFieldValue,
  level,
  formikData,
}) {
  const [IndicadorDescription, setIndicadorDescription] = useState(
    formikData.Indicator_Description,
  )

  const handleGuardar = async () => {
    try {
      setIndicadorDescription('')
      console.log(availableAnswers)
      const newArray = availableAnswers

      const removeArray = newArray
        .slice(0, 1)
        .concat(newArray.slice(1 + 1, newArray.length))

      const object = {
        ...formikData,
        QuestionnaireAnnexAnswer: removeArray,
      }

      const response = await insertMonitoringAndEvaluationQuestionnaireAnswers({
        ...object,
      })
      if (response.Success) {
        setIndicadorDescription(response.Data.IndicatorDescription)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (!actualValue) {
      const id =
        isRoot || isSubCategory
          ? null
          : questionsStructure?.IdAdaptabilityQuestion

      const val = actualType === InputTypes.BOOLEAN ? false : null
      const type = actualType
      const newObj = {
        IdAdaptabilityQuestion: id,
        Answer: val,
        AnswerType: type,
      }
      setAvailableAnswers((prev) => {
        const newArr = [...prev]
        newArr[level] = newObj
        return newArr
      })
    }
  }, [parentValue])

  const isRoot = questionsStructure?.ConfQuestion !== undefined

  const actualType = isRoot
    ? InputTypes.SUBCATEGORY
    : questionsStructure?.IdQuestionType

  const isSubCategory = actualType === InputTypes.SUBCATEGORY

  const actualValue =
    availableAnswers.length >= level + 1
      ? isSubCategory
        ? availableAnswers[level]?.IdAdaptabilityQuestion ?? null
        : availableAnswers[level]?.Answer ?? null
      : null

  const error =
    availableAnswers.length >= level + 1 ? availableAnswers[level]?.error : ''

  const hasNext =
    questionsStructure?.QuestionsLevel?.length > 0
      ? questionsStructure?.QuestionsLevel
      : null

  let QuestionNameFormatted = questionsStructure?.QuestionName ?? ''

  if (questionsStructure?.QuestionName && parentValue) {
    // TODO: Revisar formateo del QuestionName
    QuestionNameFormatted = formatQuestionName(
      questionsStructure?.QuestionName,
      parentValue,
    )
  }

  let options = []
  let nextQuestionStructure = null
  if (actualType === InputTypes.SUBCATEGORY) {
    // Si el tipo actual es SubCategory, la estructura interna sera un arreglo.
    // Generar proyeccion con solo la llave y valor.
    options = hasNext?.map((field) => {
      return { label: field.QuestionName, id: field.IdAdaptabilityQuestion }
    })

    nextQuestionStructure = hasNext?.find((questionStructure) => {
      return questionStructure.IdAdaptabilityQuestion === actualValue
    })
  } else {
    nextQuestionStructure = hasNext ? hasNext[0] : null
  }

  if (isRoot && hasNext?.length <= 0) return <></>
  // Si parentValue == null empieza en el componente raiz, si existen preguntas, pintar selectBox

  // TODO: Revisar validacion para las preguntas bool que paran el flujo.
  /** Para los casos que dependen del valor ingresado para continuar o detener el flujo */
  let stopFlow = false

  if (questionsStructure?.IsDependent) {
    stopFlow = !actualValue
  }

  return (
    <>
      <RenderField
        dataType={isRoot ? ROOT_FIELD_TYPE : actualType}
        level={level}
        availableAnswers={availableAnswers}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        options={options}
        idAdaptabilityQuestion={
          isRoot ? ROOT_ID : questionsStructure?.IdAdaptabilityQuestion
        }
        listOptionValues={questionsStructure?.ListOptionValues}
        parentValue={parentValue}
        parentValueType={parentValueType}
        isGroupResponse={questionsStructure?.GroupResponse}
        label={QuestionNameFormatted}
        error={!!error}
        errorMessage={error}
        isEditable={
          formikData.StatusDescription === 'En revisión' ||
          formikData.StatusDescription === 'Cancelado'
        }
      />
      {actualValue && hasNext && !stopFlow && (
        <CustomForm
          questionsStructure={nextQuestionStructure}
          availableAnswers={availableAnswers}
          setAvailableAnswers={setAvailableAnswers}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          parentValue={actualValue}
          parentValueType={actualType}
          level={level + 1}
          formikData={formikData}
        />
      )}
      {!stopFlow && !hasNext && actualValue && (
        <>
          <Grid className="buttonsPYME">
            <Button
              variant="contained"
              color="success"
              style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
              onClick={() => handleGuardar()}
            >
              Generar indicador
            </Button>
          </Grid>
          {IndicadorDescription !== '' && (
            <Grid container spacing={2} clasName="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    disabled
                    id="outlined-basic"
                    variant="outlined"
                    value={IndicadorDescription}
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </>
  )
}

export function RenderField({
  idAdaptabilityQuestion,
  index,
  dataType,
  label,
  placeholder,
  item,
  options,
  error,
  setInfoReady,
  availableAnswers,
  touched,
  errorMessage,
  handleBlur,
  handleChange,
  setFieldValue,
  isEditable,
  permissions,
  setInfoReadyForSubprocess,
  level,
  isGroupResponse,
  parentValue,
  parentValueType,
  listOptionValues,
}) {
  // const { tipoDato, valor, options } = params;
  const Component = tiposPermitidos[dataType] || null
  return (
    <div>
      {Component && (
        <Component
          className="field"
          key={index}
          label={label}
          idAdaptabilityQuestion={idAdaptabilityQuestion}
          placeholder={placeholder}
          valueObject={availableAnswers[level]} // Buscara su valor en el contenedor de valores
          options={options}
          error={error}
          errorMessage={errorMessage}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          availableAnswers={availableAnswers} // Contenedor de valores
          disabled={isEditable}
          type={dataType}
          level={level}
          isGroupResponse={isGroupResponse}
          parentValue={parentValue}
          parentValueType={parentValueType}
          listOptionValues={listOptionValues}
        />
      )}
    </div>
  )
}

RenderField.propTypes = {
  dataType: PropTypes.number,
  item: PropTypes.object,
}

CustomForm.propTypes = {
  questionsStructure: PropTypes.object,
  availableAnswers: PropTypes.array,
  setAvailableAnswers: PropTypes.func,
  // parentValue: PropTypes.string || PropTypes.number,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  setFieldValue: PropTypes.func,
  level: PropTypes.number,
}

const tiposPermitidos = {
  1: NumberInput,
  2: TextInput,
  6: AutoCompleteInput,
  3: RadioButtonInput,
  5: SelectInput,
  7: PorcentInput,
}

// export default DependencyFormDemo;
